import gql from 'graphql-tag';

export const updateTreatment = gql`
  mutation updateTreatment($input: CreateTreatmentInput!, $id: String!) {
    updateTreatmentWithValidation(input: $input, id: $id) {
      id
    }
  }
`;
